import React from 'react';
import Svg from "../Svg";

const TrackTypeRedIcon = props => (
   <Svg width="30px" height="30px" viewBox={'30 30'}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
         <g transform="translate(-25.000000, -547.000000)">
            <g transform="translate(24.000000, 453.000000)">
               <g transform="translate(1.000000, 94.000000)">
                  <circle id="Oval-Copy" fill="#FBBAB7" fillRule="evenodd" cx="15" cy="15" r="15"/>
                  <circle id="Oval-Copy-4" fill="#FF3B30" fillRule="evenodd" cx="15" cy="15"
                          r="11.6666667"/>
                  <text fontFamily="MapFont, Open Sans" fontSize="14" fontWeight="normal"
                        fill="#FFFFFF">
                     <tspan x="8.02701823" y="19.0833333">1А</tspan>
                  </text>
               </g>
            </g>
         </g>
      </g>
   </Svg>
);

export default TrackTypeRedIcon;
